module.exports = __webpack_public_path__ + "static/Supermercado-1ee143bc9bc72a069865e49d5c12cad2.jpg";